import type { SpartacuxShoppingCartState } from '../ShoppingCartState';

export const selectAddToCartModalIsFetching = (
  state: SpartacuxShoppingCartState,
) =>
  state.shoppingCart?.addToCartModal?.productRecommendation?.fetching || false;
